module.exports = {
    faRole:"FA",
    // roles TBD
    risRole:"RIS",
    opsRole:"Ops",
    NoteMessages: {
        saveNoteSuccess : "Note Added Successfully.",
        saveNoteFailure: "Something went wrong while saving Note, Try again."
    },
    serverIANATimezoneString: "America/Boise"
}


// WEBPACK FOOTER //
// ./src/constants.js